import { deleteChatSession } from './deleteChatSession'
import { disableChat } from './disableChat'

/**
 * @param {LCChatDeactivatedEvent} payload
 */
export function handleChatDeactivated(payload) {
  console.info('chat deactivated:', payload)

  deleteChatSession()
  disableChat()
}
